import React, {Fragment, useState, useEffect} from 'react'
import PropTypes from 'prop-types';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';

import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Divider } from '@mui/material';
import Avatar from '@mui/material/Avatar';

import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import Chip from '@mui/material/Chip';
import LinearProgress from '@mui/material/LinearProgress';

import List from '@mui/material/List';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListSubheader from '@mui/material/ListSubheader';
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
import ListItemButton from '@mui/material/ListItemButton';
import CreditScoreIcon from '@mui/icons-material/CreditScore';
import LockClockIcon from '@mui/icons-material/LockClock';
import { useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import Popover from '@mui/material/Popover';
import HelpIcon from '@mui/icons-material/Help';
import IconButton from '@mui/material/IconButton';
import Alert from '@mui/material/Alert';
import Button from '@mui/material/Button';
import AddchartIcon from '@mui/icons-material/Addchart';
import { useNavigate } from 'react-router-dom';

import { setCopyings } from '../../request/Analysis/hitorySlice';
import { useDispatch } from 'react-redux';
import { useMutation } from "react-query";
import apiClient from "../../request/http-common";
import { Currency } from '@depay/local-currency';

import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import InputLabel from '@mui/material/InputLabel';
import FormControl from '@mui/material/FormControl';
import OutlinedInput from '@mui/material/OutlinedInput';

import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import Slide from '@mui/material/Slide';

import ReactApexChart from 'react-apexcharts';
import { AdvancedRealTimeChart } from "react-ts-tradingview-widgets";

// for new payment method
import { QRCode } from 'react-qrcode-logo';
import TextField from '@mui/material/TextField';
import {CopyToClipboard} from 'react-copy-to-clipboard';
import CircularProgress from '@mui/material/CircularProgress';
import SmallChart from './SmallChart';

// Professional icons
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import PeopleIcon from '@mui/icons-material/People';
import ScheduleIcon from '@mui/icons-material/Schedule';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import StarIcon from '@mui/icons-material/Star';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const TraderSingle = () => {
  
  const formatFollowers = (count) => {
    count = parseInt(count);
    if (count >= 1000000) {
        return (count / 1000000).toFixed(1) + 'M';
    } else if (count >= 1000) {
        return (count / 1000).toFixed(1) + 'K';
    }
    return count;
};

  const user = useSelector((state) => state.user.user);
  const coinRates = useSelector((state) => state.coins.coinRates);
  const addresses = useSelector((state) => state.coins.addresses);
  const appMode = useSelector((state) => state.mode.mode);

  const params = useParams();
  const dispatch = useDispatch();
  const [rate, setRate] = useState(1);

  const calculateBalance = (coin) => coin.balance === null ? 0 : coin.balance

  const [traderId, settraderId] = useState();
  const [selectedtrader, setSelectedtrader] = useState('');
  const [source, setSource] = useState('');
  const [proportion, setProportion] = useState('');
  const [error, setErros] = useState('');
  const navigate = useNavigate();

  const callRate = async()=> {
    if(user.currency === 'USD'){
      setRate(1);
    }else{
      await Currency.fromUSD({ amount: 1 }).then(amount=>{
        setRate(amount.amount);
       });
    }  
};

  const traders = useSelector((state) => state.traders.traders);
  const getDate = (date) => new Date(date).toLocaleString('en-GB', {
    hour12: false,
  });

  // Helper function to get TradingView chart symbol based on asset type
  const getChartSymbol = (trade) => {
    const currency = trade.currency || 'EUR/USD';
    const assetType = trade.asset_type || 'forex';
    
    switch (assetType) {
      case 'crypto':
        // For crypto pairs like BTC/USDT, ETH/USDT
        const cryptoSymbol = currency.replace('/', '');
        return `BINANCE:${cryptoSymbol}`;
        
      case 'stocks':
        // For stock symbols like AAPL, GOOGL, MSFT
        const stockSymbol = currency.replace('/', '');
        return `NASDAQ:${stockSymbol}`;
        
      case 'forex':
      default:
        // For forex pairs like EUR/USD, GBP/USD
        const forexSymbol = currency.replace('/', '');
        return `FX:${forexSymbol}`;
    }
  };

  function CustomTabPanel(props) {
    const { children, value, index, ...other } = props;
  
    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
      >
        {value === index && (
          <Box sx={{ p: { xs: 1, sm: 2 } }}>
            {children}
          </Box>
        )}
      </div>
    );
  }

  function a11yProps(index) {
    return {
      id: `simple-tab-${index}`,
      'aria-controls': `simple-tabpanel-${index}`,
    };
  }

  const calcPercentage = (profit, loss) => {
    let total = parseFloat(profit) + parseFloat(loss);
    let percent = profit/total;
    return percent * 100;
 }
 
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  
  const formatPrice = (amount)=> new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', currencySign: 'standard' }).format(amount);

   // for new balance method
   const [buttonText, setbuttonText] = useState(null);
   const [selectedCoin, setSelectedCoin] = useState(null);

   const getCoinDetails = (coinName) => {
     switch (coinName) {
       case 'Overall Asset':
         setSelectedCoin(null) 
         break;
       case 'Referral Wallet':
         setSelectedCoin(null) 
         break;
       default:
         addresses.forEach(address => {
           if (address.coin_name === coinName) {       
             setSelectedCoin(address)            
           }
         });
         break;
     }
   }

  const { isLoading: isInvesting, mutate: postInvestment } = useMutation(
    async () => {
      return await apiClient.post(`/api/store-copy`, {
        trader_id: traderId,
        amount: amount, 
        proportion: proportion,
        payment_source: source
      });
    },
    {
      onSuccess: (res) => {
          if (res.data.status === 'success') {
            localStorage.setItem('notification', JSON.stringify({message : `${res.data.message}`, 'type': 'success' }));
            const event = new Event('newMessage');
            window.dispatchEvent(event);
            dispatch(setCopyings(res.data.investments));
            setTimeout(() => {
              navigate('/copy-history');
            }, 2000);
          }            
      },
      onError: (err) => {
            if (err.response?.data.length) {
              let myerror = err.response?.data || err;         
          setErros(myerror.errors)               
          }else{
              let errorMessage = err.response?.data.message || err ;
              localStorage.setItem('notification', JSON.stringify({message : `${errorMessage}`, 'type': 'error' }));
              const event = new Event('newMessage');
              window.dispatchEvent(event);
          }
      },
    }
  );
  
  const [open, setOpen] = React.useState(false);
  const [amount, setAmount] = useState(0);
  const [currentTrader, setcurrentTrader] = useState(null);

  const fundingBal = useSelector((state) => state.wallet.fundingBalance);
    const subBal = useSelector((state) => state.wallet.subscriptionBalance);
    const refBal = useSelector((state) => state.wallet.referralBalance);
    const mainBal = useSelector((state) => state.wallet.withdrawableBalance);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const getSeriesdata = (targetPercentage) => {
    let data = [];
    const now = new Date();
    const sevenDaysAgo = new Date(now.getTime() - (7 * 24 * 60 * 60 * 1000));
    
    let currentPercentage = 0;
    for (let i = 0; i < 7; i++) {
      const date = new Date(sevenDaysAgo.getTime() + (i * 24 * 60 * 60 * 1000));
      
      const remainingDays = 7 - i;
      const averageStepNeeded = (targetPercentage - currentPercentage) / remainingDays;
      const randomStep = averageStepNeeded * (0.5 + Math.random());
      
      currentPercentage += randomStep;
      
      const variation = targetPercentage * 0.05;
      const value = currentPercentage + (variation * (Math.random() - 0.5));
      
      data.push({
        x: date.getTime(),
        y: parseFloat(value.toFixed(2))
      });
    }
    
    return data;
  };

  const options = {
    chart: {
      type: 'area',
      height: 300,
      toolbar: { show: false },
      zoom: { enabled: false },
      background: 'transparent'
    },
    grid: {
      borderColor: 'rgba(139, 142, 147, 0.1)',
      strokeDashArray: 3,
      xaxis: { lines: { show: true, opacity: 0.1 } },
      yaxis: { lines: { show: true, opacity: 0.1 } }
    },
    dataLabels: { enabled: false },
    stroke: {
      curve: 'smooth',
      width: 3,
      colors: ['var(--primary-orange)']
    },
    fill: {
      type: 'gradient',
      gradient: {
        shadeIntensity: 1,
        opacityFrom: 0.4,
        opacityTo: 0.1,
        stops: [0, 90, 100],
        colorStops: [
          { offset: 0, color: 'var(--primary-orange)', opacity: 0.4 },
          { offset: 100, color: 'var(--primary-orange)', opacity: 0.1 }
        ]
      }
    },
    colors: ['var(--primary-orange)'],
    xaxis: {
      type: 'datetime',
      labels: {
        style: { colors: 'var(--text-secondary)', fontSize: '12px' },
        formatter: function(val) {
          return new Date(val).toLocaleDateString();
      }
      },
      axisBorder: { show: false },
      axisTicks: { show: false }
    },
    yaxis: {
      labels: {
        style: { colors: 'var(--text-secondary)', fontSize: '12px' },
        formatter: function(val) {
          return val.toFixed(1) + '%';
        }
      }
    },
    tooltip: {
      theme: appMode,
      x: { format: 'dd MMM yyyy' },
      style: { fontSize: '12px' },
      y: {
        formatter: function(value) {
          return value + '%'
        }
      }
    }
  };

  return (
    <div className="page-wrapper">
      <Box sx={{ 
        paddingX: { xs: 2, md: 3 }, 
        paddingTop: { xs: 2, sm: 1, md: 0 },
        maxWidth: '1200px', 
        margin: '0 auto' 
      }}>
      {traders.map(trader => (
        parseInt(trader.id) === parseInt(params.id) &&
        
          <Fragment key={trader.id}>
            
            {/* Professional Header Section */}
            <Card className="modern-card" sx={{ marginBottom: 3, overflow: 'visible' }}>
              <CardContent sx={{ padding: { xs: 2, sm: 3, md: 4 } }}>
                
                {/* Main Header */}
                <Box sx={{ 
                  display: 'flex', 
                  flexDirection: { xs: 'column', md: 'row' },
                  alignItems: { xs: 'center', md: 'flex-start' },
                  justifyContent: 'space-between',
                  gap: { xs: 2, sm: 3 },
                  marginBottom: { xs: 2, sm: 3 }
                }}>
                  
                  {/* Trader Info */}
                  <Box sx={{ 
                    display: 'flex', 
                    alignItems: 'center', 
                    gap: { xs: 2, sm: 3 },
                    textAlign: { xs: 'center', md: 'left' }
                  }}>
                    <Avatar 
                      alt={trader.trader_name} 
                      src={trader.image}
                      sx={{ 
                        width: { xs: 80, md: 100 }, 
                        height: { xs: 80, md: 100 },
                        border: '3px solid var(--primary-orange)',
                        boxShadow: 'var(--shadow-glow)'
                      }}
                    />
                    <Box>
                      <Typography 
                        variant="h4" 
                        className="text-display gradient-text"
                        sx={{ 
                          fontWeight: 700, 
                          marginBottom: 1,
                          fontSize: { xs: '1.5rem', sm: '1.8rem', md: '2.125rem' }
                        }}
                      >
                        {trader.trader_name}
                      </Typography>
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, marginBottom: 1 }}>
                        <StarIcon sx={{ 
                          color: 'var(--primary-orange)', 
                          fontSize: { xs: 16, sm: 20 }
                        }} />
                        <Typography 
                          variant="body2" 
                          className="text-secondary"
                          sx={{ fontSize: { xs: '0.8rem', sm: '0.875rem' } }}
                        >
                          Professional Trader
                        </Typography>
                      </Box>
                      <Chip 
                        label={`Level ${trader.level || 'Expert'}`}
                        sx={{
                          background: 'var(--gradient-primary)',
                          color: 'white',
                          fontWeight: 600,
                          borderRadius: 'var(--radius-md)',
                          fontSize: { xs: '0.75rem', sm: '0.8125rem' },
                          height: { xs: 24, sm: 32 }
                        }}
                      />
                    </Box>
                  </Box>

                  {/* Copy Button */}
                  <Button 
                    onClick={() => {
                handleClickOpen();
                settraderId(trader.id);
                setSelectedtrader(trader);
                setAmount(parseFloat(trader.min_amount))
                    }}
                    variant="contained"
                    size="large"
                    sx={{
                      minWidth: { xs: '100%', md: 180 },
                      height: 56,
                      fontSize: 16,
                      fontWeight: 700,
                      textTransform: 'none',
                      background: 'var(--gradient-primary)',
                      color: '#FFFFFF',
                      border: 'none',
                      boxShadow: 'var(--shadow-glow)',
                      '&:hover': {
                        background: 'var(--gradient-primary)',
                        transform: 'translateY(-2px)',
                        boxShadow: '0 12px 32px rgba(247, 147, 26, 0.4)',
                        color: '#FFFFFF'
                      },
                      '& .MuiButton-startIcon': {
                        color: '#FFFFFF'
                      }
                    }}
                    startIcon={<AddchartIcon />}
                  >
                    Copy Trader
              </Button>
            </Box>

                {/* Stats Grid - Mobile Optimized */}
                <Grid container spacing={{ xs: 1.5, sm: 3 }}>
                  <Grid item xs={6} sm={3}>
                    <Box className="trading-card" sx={{ 
                      textAlign: 'center', 
                      padding: { xs: 1.5, sm: 2 },
                      minHeight: { xs: 85, sm: 'auto' }
                    }}>
                      <PeopleIcon sx={{ 
                        color: 'var(--primary-orange)', 
                        fontSize: { xs: 20, sm: 28 }, 
                        marginBottom: { xs: 0.5, sm: 1 }
                      }} />
                      <Typography 
                        variant="caption" 
                        className="text-secondary" 
                        display="block"
                        sx={{ fontSize: { xs: '0.75rem', sm: '0.875rem' } }}
                      >
                Followers
                </Typography>
                      <Typography 
                        variant="h6" 
                        className="text-primary" 
                        sx={{ 
                          fontWeight: 700,
                          fontSize: { xs: '1.1rem', sm: '1.5rem' }
                        }}
                      >
                {formatFollowers(trader.copiers)}
                </Typography>
              </Box>
                  </Grid>
                  
                  <Grid item xs={6} sm={3}>
                    <Box className="trading-card" sx={{ 
                      textAlign: 'center', 
                      padding: { xs: 1.5, sm: 2 },
                      minHeight: { xs: 85, sm: 'auto' }
                    }}>
                      <ScheduleIcon sx={{ 
                        color: 'var(--success-green)', 
                        fontSize: { xs: 20, sm: 28 }, 
                        marginBottom: { xs: 0.5, sm: 1 }
                      }} />
                      <Typography 
                        variant="caption" 
                        className="text-secondary" 
                        display="block"
                        sx={{ fontSize: { xs: '0.75rem', sm: '0.875rem' } }}
                      >
                Trading Days
                </Typography>
                      <Typography 
                        variant="h6" 
                        className="text-primary" 
                        sx={{ 
                          fontWeight: 700,
                          fontSize: { xs: '1.1rem', sm: '1.5rem' }
                        }}
                      >
                {trader.duration}
                </Typography>
              </Box>
                  </Grid>
                  
                  <Grid item xs={6} sm={3}>
                    <Box className="trading-card" sx={{ 
                      textAlign: 'center', 
                      padding: { xs: 1.5, sm: 2 },
                      minHeight: { xs: 85, sm: 'auto' }
                    }}>
                      <AttachMoneyIcon sx={{ 
                        color: 'var(--warning-yellow)', 
                        fontSize: { xs: 20, sm: 28 }, 
                        marginBottom: { xs: 0.5, sm: 1 }
                      }} />
                      <Typography 
                        variant="caption" 
                        className="text-secondary" 
                        display="block"
                        sx={{ fontSize: { xs: '0.75rem', sm: '0.875rem' } }}
                      >
                Min Stake
                </Typography>
                      <Typography 
                        variant="h6" 
                        className="text-primary" 
                        sx={{ 
                          fontWeight: 700,
                          fontSize: { xs: '1.1rem', sm: '1.5rem' }
                        }}
                      >
                {formatPrice(trader.min_amount)}
                </Typography>
              </Box>
                  </Grid>
                  
                  <Grid item xs={6} sm={3}>
                    <Box className="trading-card" sx={{ 
                      textAlign: 'center', 
                      padding: { xs: 1.5, sm: 2 },
                      minHeight: { xs: 85, sm: 'auto' }
                    }}>
                      <TrendingUpIcon sx={{ 
                        color: 'var(--success-green)', 
                        fontSize: { xs: 20, sm: 28 }, 
                        marginBottom: { xs: 0.5, sm: 1 }
                      }} />
                      <Typography 
                        variant="caption" 
                        className="text-secondary" 
                        display="block"
                        sx={{ fontSize: { xs: '0.75rem', sm: '0.875rem' } }}
                      >
                        Total ROI
                      </Typography>
                      <Typography 
                        variant="h6" 
                        className="text-success" 
                        sx={{ 
                          fontWeight: 700,
                          fontSize: { xs: '1.1rem', sm: '1.5rem' }
                        }}
                      >
                        +{trader.gain}%
                      </Typography>
            </Box>
                  </Grid>
                </Grid>

                {/* Description */}
                {trader.description && (
                  <Box sx={{ 
                    marginTop: { xs: 2, sm: 3 }, 
                    padding: { xs: 1.5, sm: 2 }, 
                    background: 'var(--bg-tertiary)', 
                    borderRadius: 'var(--radius-md)' 
                  }}>
                    <Typography 
                      variant="body1" 
                      className="text-secondary" 
                      sx={{ 
                        lineHeight: 1.6,
                        fontSize: { xs: '0.875rem', sm: '1rem' }
                      }}
                    >
                {trader.description}
              </Typography>
            </Box>
                )}
              </CardContent>
            </Card>

            {/* Performance Chart - Mobile Optimized */}
            <Card className="modern-card chart-container" sx={{ marginBottom: 3 }}>
              <CardContent sx={{ padding: 0 }}>
                <Box sx={{ padding: { xs: 2, sm: 3 }, paddingBottom: 0 }}>
                  <Typography 
                    variant="h6" 
                    className="text-heading" 
                    sx={{ 
                      marginBottom: 2,
                      fontSize: { xs: '1.1rem', sm: '1.25rem' }
                    }}
                  >
                    Performance Chart
                  </Typography>
                </Box>
            <ReactApexChart
                    options={options}
                    series={[{
                    name: 'Profit %',
                      data: getSeriesdata(parseFloat(trader.gain))
                    }]}
                    type="area"
                  height={window.innerWidth < 600 ? 250 : 300}
                />
              </CardContent>
            </Card>
         
            {/* Tabs Section */}
            <Card className="modern-card">
              <Box sx={{ borderBottom: 1, borderColor: 'var(--border-primary)' }}>
                <Tabs 
                  value={value} 
                  onChange={handleChange} 
                  centered
                  sx={{
                    '& .MuiTab-root': {
                      color: 'var(--text-secondary)',
                      fontWeight: 600,
                      fontSize: '16px',
                      textTransform: 'none',
                      padding: '16px 32px'
                    },
                    '& .MuiTab-root.Mui-selected': {
                      color: 'var(--primary-orange)',
                    },
                    '& .MuiTabs-indicator': {
                      background: 'var(--gradient-primary)',
                      height: 3,
                      borderRadius: '2px 2px 0 0'
                    }
                  }}
                >
                  <Tab label="Performance Summary" {...a11yProps(0)} />
                  <Tab label="Trade History" {...a11yProps(1)} />
                      </Tabs>
                    </Box>

                    <CustomTabPanel value={value} index={0}>
                {/* Enhanced Summary Content - Mobile Optimized */}
                <Grid container spacing={{ xs: 1.5, md: 3 }}>
                  {/* Performance Metrics */}
                  <Grid item xs={12} md={8}>
                    <Card className="trading-card" sx={{ height: '100%' }}>
                      <CardContent sx={{ padding: { xs: 2, sm: 3 } }}>
                        <Typography 
                          variant="h6" 
                          className="text-heading" 
                          sx={{ 
                            marginBottom: { xs: 2, sm: 3 },
                            fontSize: { xs: '1.1rem', sm: '1.25rem' }
                          }}
                        >
                          Trading Performance
                        </Typography>

                        <Grid container spacing={{ xs: 2, sm: 3 }}>
                          <Grid item xs={6}>
                            <Box sx={{ textAlign: 'center' }}>
                              <Typography 
                                variant="caption" 
                                className="text-secondary"
                                sx={{ fontSize: { xs: '0.7rem', sm: '0.875rem' } }}
                              >
                                ROI ({trader.duration} days)
                          </Typography>
                              <Typography 
                                variant="h4" 
                                className="text-success gradient-text"
                                sx={{ 
                                  fontWeight: 700, 
                                  margin: { xs: '4px 0', sm: '8px 0' },
                                  fontSize: { xs: '1.8rem', sm: '2.125rem' }
                                }}
                              >
                                +{trader.gain}%
                              </Typography>
                            </Box>
                          </Grid>
                          
                          <Grid item xs={6}>
                            <Box sx={{ textAlign: 'center' }}>
                              <Typography 
                                variant="caption" 
                                className="text-secondary"
                                sx={{ fontSize: { xs: '0.7rem', sm: '0.875rem' } }}
                              >
                                Active Followers
                                  </Typography>
                              <Typography 
                                variant="h4" 
                                className="text-primary"
                                sx={{ 
                                  fontWeight: 700, 
                                  margin: { xs: '4px 0', sm: '8px 0' },
                                  fontSize: { xs: '1.8rem', sm: '2.125rem' }
                                }}
                              >
                                {formatFollowers(trader.copiers)}
                              </Typography>
                              </Box>
                          </Grid>
                        </Grid>

                        <Box sx={{ marginTop: { xs: 2, sm: 3 } }}>
                          <Box sx={{ 
                            display: 'flex', 
                            justifyContent: 'space-between', 
                            marginBottom: { xs: 1.5, sm: 2 }
                          }}>
                              <Box>
                              <Typography 
                                variant="caption" 
                                className="text-secondary"
                                sx={{ fontSize: { xs: '0.7rem', sm: '0.875rem' } }}
                              >
                                Total Profit
                                  </Typography>
                              <Typography 
                                variant="h6" 
                                className="text-success" 
                                sx={{ 
                                  fontWeight: 600,
                                  fontSize: { xs: '1rem', sm: '1.25rem' }
                                }}
                              >
                                {formatPrice(trader.profit)}
                              </Typography>
                              </Box>

                            <Box sx={{ textAlign: 'right' }}>
                              <Typography 
                                variant="caption" 
                                className="text-secondary"
                                sx={{ fontSize: { xs: '0.7rem', sm: '0.875rem' } }}
                              >
                                Total Loss
                              </Typography>
                              <Typography 
                                variant="h6" 
                                className="text-danger" 
                                sx={{ 
                                  fontWeight: 600,
                                  fontSize: { xs: '1rem', sm: '1.25rem' }
                                }}
                              >
                                {formatPrice(trader.loss)}
                              </Typography>
                          </Box> 
                          </Box>
                          
                          <LinearProgress 
                            variant="determinate" 
                            value={calcPercentage(trader.profit, trader.loss)}
                            sx={{
                              height: { xs: 6, sm: 8 },
                              borderRadius: 4,
                              backgroundColor: 'var(--danger-red-bg)',
                              '& .MuiLinearProgress-bar': {
                                background: 'var(--gradient-success)',
                                borderRadius: 4
                              }
                            }}
                          />
                          <Box sx={{ 
                            display: 'flex', 
                            justifyContent: 'space-between', 
                            marginTop: { xs: 0.5, sm: 1 },
                            flexDirection: { xs: 'column', sm: 'row' },
                            gap: { xs: 0.5, sm: 0 }
                          }}>
                            <Typography 
                              variant="caption" 
                              className="text-success"
                              sx={{ fontSize: { xs: '0.7rem', sm: '0.875rem' } }}
                            >
                              {calcPercentage(trader.profit, trader.loss).toFixed(1)}% Win Rate
                            </Typography>
                            <Typography 
                              variant="caption" 
                              className="text-secondary"
                              sx={{ fontSize: { xs: '0.7rem', sm: '0.875rem' } }}
                            >
                              Based on historical data
                            </Typography>
                            </Box>
                        </Box>
                      </CardContent>
                    </Card>
                  </Grid>

                  {/* Additional Stats */}
                  <Grid item xs={12} md={4}>
                    <Card className="trading-card" sx={{ height: '100%' }}>
                      <CardContent sx={{ padding: { xs: 2, sm: 3 } }}>
                        <Typography 
                          variant="h6" 
                          className="text-heading" 
                          sx={{ 
                            marginBottom: { xs: 2, sm: 3 },
                            fontSize: { xs: '1.1rem', sm: '1.25rem' }
                          }}
                        >
                          Quick Stats
                              </Typography>

                        <Box sx={{ display: 'flex', flexDirection: 'column', gap: { xs: 1.5, sm: 2 } }}>
                          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                            <Typography 
                              variant="body2" 
                              className="text-secondary"
                              sx={{ fontSize: { xs: '0.8rem', sm: '0.875rem' } }}
                            >
                              Level
                            </Typography>
                            <Typography 
                              variant="body2" 
                              className="text-primary"
                              sx={{ fontSize: { xs: '0.8rem', sm: '0.875rem' } }}
                            >
                              {trader.level || 'N/A'}
                            </Typography>
                          </Box>
                          
                          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                            <Typography 
                              variant="body2" 
                              className="text-secondary"
                              sx={{ fontSize: { xs: '0.8rem', sm: '0.875rem' } }}
                            >
                              Copiers
                            </Typography>
                            <Typography 
                              variant="body2" 
                              className="text-primary"
                              sx={{ fontSize: { xs: '0.8rem', sm: '0.875rem' } }}
                            >
                              {formatFollowers(trader.copiers)}
                            </Typography>
                        </Box> 
                          
                          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                            <Typography 
                              variant="body2" 
                              className="text-secondary"
                              sx={{ fontSize: { xs: '0.8rem', sm: '0.875rem' } }}
                            >
                              Total Profit
                            </Typography>
                            <Typography 
                              variant="body2" 
                              className="text-success"
                              sx={{ fontSize: { xs: '0.8rem', sm: '0.875rem' } }}
                            >
                              {trader.profit ? formatPrice(trader.profit) : 'N/A'}
                            </Typography>
                          </Box>
                          
                          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                            <Typography 
                              variant="body2" 
                              className="text-secondary"
                              sx={{ fontSize: { xs: '0.8rem', sm: '0.875rem' } }}
                            >
                              Commission
                            </Typography>
                            <Typography 
                              variant="body2" 
                              className="text-primary"
                              sx={{ fontSize: { xs: '0.8rem', sm: '0.875rem' } }}
                            >
                              {trader.commission ? `${trader.commission}%` : 'N/A'}
                            </Typography>
                          </Box>
                          </Box>
                        </CardContent>
                      </Card>
                  </Grid>
                </Grid>
                    </CustomTabPanel>

                    <CustomTabPanel value={value} index={1}>
                {/* Enhanced Trades List - Mobile Optimized */}
                {trader.trades.length > 0 ? (
                  <Box sx={{ display: 'flex', flexDirection: 'column', gap: { xs: 1, sm: 2 } }}>
                    {trader.trades.map((trade, index) => (
                      <Card key={trade.id || index} className="trading-card">
                        <Accordion 
                          sx={{ 
                            background: 'transparent',
                            boxShadow: 'none',
                            '&:before': { display: 'none' }
                          }}
                        >
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon sx={{ color: 'var(--text-secondary)', fontSize: { xs: 20, sm: 24 } }} />}
                            sx={{ 
                              padding: { xs: '8px 16px', sm: '16px' },
                              minHeight: { xs: 48, sm: 'auto' }
                            }}
                          >
                            <Grid container alignItems="center" spacing={{ xs: 1, sm: 2 }}>
                              <Grid item xs={12} sm={6}>
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: { xs: 1, sm: 2 } }}>
                                  <Chip 
                                    label={trade.trade_type}
                                    size="small"
                                    sx={{
                                      background: trade.trade_type === 'BUY' ? 'var(--success-green-bg)' : 'var(--danger-red-bg)',
                                      color: trade.trade_type === 'BUY' ? 'var(--success-green)' : 'var(--danger-red)',
                                      fontWeight: 600,
                                      fontSize: { xs: '0.7rem', sm: '0.8125rem' },
                                      height: { xs: 20, sm: 24 }
                                    }}
                                  />
                                  <Box>
                                    <Typography 
                                      variant="h6" 
                                      className="text-primary" 
                                      sx={{ 
                                        fontWeight: 600,
                                        fontSize: { xs: '0.95rem', sm: '1.25rem' }
                                      }}
                                    >
                                      {trade.currency}
                                    </Typography>
                                    <Typography 
                                      variant="caption" 
                                      className="text-secondary"
                                      sx={{ fontSize: { xs: '0.7rem', sm: '0.875rem' } }}
                                    >
                                      #{trade.order_id}
                                  </Typography>
                              </Box>
                            </Box>
                              </Grid>
                              
                              <Grid item xs={6} sm={3}>
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: { xs: 0.5, sm: 1 } }}>
                                  <LockClockIcon sx={{ 
                                    color: 'var(--text-secondary)', 
                                    fontSize: { xs: 14, sm: 16 }
                                  }} />
                                  <Typography 
                                    variant="caption" 
                                    className="text-secondary"
                                    sx={{ fontSize: { xs: '0.7rem', sm: '0.875rem' } }}
                                  >
                                    {trade.status}
                                  </Typography>
                              </Box>
                              </Grid>
                              
                              <Grid item xs={6} sm={3} sx={{ textAlign: { xs: 'left', sm: 'right' } }}>
                                <Typography 
                                  variant="h6" 
                                  className={trade.amount > 0 ? 'text-success' : 'text-danger'}
                                  sx={{ 
                                    fontWeight: 700,
                                    fontSize: { xs: '0.95rem', sm: '1.25rem' }
                                  }}
                                >
                                  {trade.amount > 0 ? '+' : ''}{formatPrice(trade.amount)}
                                </Typography>
                              </Grid>
                            </Grid>
                        </AccordionSummary>

                          <AccordionDetails sx={{ padding: { xs: '8px 16px 16px', sm: '16px' } }}>
                            <Divider sx={{ marginBottom: { xs: 1.5, sm: 2 }, borderColor: 'var(--border-primary)' }} />
                            
                            <Grid container spacing={{ xs: 1, sm: 2 }} sx={{ marginBottom: { xs: 2, sm: 3 } }}>
                              <Grid item xs={6} sm={3}>
                                <Typography 
                                  variant="caption" 
                                  className="text-secondary"
                                  sx={{ fontSize: { xs: '0.7rem', sm: '0.875rem' } }}
                                >
                                  Open Time
                                </Typography>
                                <Typography 
                                  variant="body2" 
                                  className="text-primary"
                                  sx={{ 
                                    fontSize: { xs: '0.8rem', sm: '0.875rem' },
                                    wordBreak: 'break-all'
                                  }}
                                >
                                  {getDate(trade.open_time)}
                                </Typography>
                              </Grid>
                              
                              <Grid item xs={6} sm={3}>
                                <Typography 
                                  variant="caption" 
                                  className="text-secondary"
                                  sx={{ fontSize: { xs: '0.7rem', sm: '0.875rem' } }}
                                >
                                  Close Time
                                </Typography>
                                <Typography 
                                  variant="body2" 
                                  className="text-primary"
                                  sx={{ 
                                    fontSize: { xs: '0.8rem', sm: '0.875rem' },
                                    wordBreak: 'break-all'
                                  }}
                                >
                                  {getDate(trade.close_time)}
                                </Typography>
                              </Grid>

                              <Grid item xs={6} sm={3}>
                                <Typography 
                                  variant="caption" 
                                  className="text-secondary"
                                  sx={{ fontSize: { xs: '0.7rem', sm: '0.875rem' } }}
                                >
                                  Asset Type
                                </Typography>
                                <Chip 
                                  label={(trade.asset_type || 'forex').toUpperCase()}
                                  size="small"
                                  sx={{
                                    background: trade.asset_type === 'crypto' ? 'var(--warning-yellow-bg)' : 
                                               trade.asset_type === 'stocks' ? 'var(--info-blue-bg)' : 'var(--primary-orange-bg)',
                                    color: trade.asset_type === 'crypto' ? 'var(--warning-yellow)' : 
                                           trade.asset_type === 'stocks' ? 'var(--info-blue)' : 'var(--primary-orange)',
                                    fontWeight: 600,
                                    fontSize: { xs: '0.65rem', sm: '0.75rem' },
                                    height: { xs: 18, sm: 22 },
                                    marginTop: 0.5
                                  }}
                                />
                              </Grid>

                              {trade.leverage && (
                                <Grid item xs={6} sm={3}>
                                  <Typography 
                                    variant="caption" 
                                    className="text-secondary"
                                    sx={{ fontSize: { xs: '0.7rem', sm: '0.875rem' } }}
                                  >
                                    Leverage
                                  </Typography>
                                  <Typography 
                                    variant="body2" 
                                    className="text-primary"
                                    sx={{ fontSize: { xs: '0.8rem', sm: '0.875rem' } }}
                                  >
                                    {trade.leverage}x
                                  </Typography>
                                </Grid>
                              )}
                            </Grid>

                            {/* Entry Reason */}
                            {trade.entry_reason && (
                              <Box sx={{ 
                                marginBottom: { xs: 2, sm: 3 }, 
                                padding: { xs: 1.5, sm: 2 },
                                background: 'var(--bg-tertiary)',
                                borderRadius: 'var(--radius-md)',
                                border: '1px solid var(--border-primary)'
                              }}>
                                <Typography 
                                  variant="caption" 
                                  className="text-secondary"
                                  sx={{ fontSize: { xs: '0.7rem', sm: '0.875rem' }, display: 'block', marginBottom: 0.5 }}
                                >
                                  Entry Reason
                                </Typography>
                                <Typography 
                                  variant="body2" 
                                  className="text-primary"
                                  sx={{ fontSize: { xs: '0.8rem', sm: '0.875rem' } }}
                                >
                                  {trade.entry_reason}
                                </Typography>
                              </Box>
                            )}

                            <Box 
                              className="chart-container" 
                              sx={{ 
                                borderRadius: 'var(--radius-md)', 
                                overflow: 'hidden',
                                minHeight: { xs: 300, sm: 400 }
                              }}
                            >
                              <AdvancedRealTimeChart
                                symbol={getChartSymbol(trade)}
                                interval="1"
                                timezone="Etc/UTC"
                                theme={appMode}
                                locale="en"
                                hide_top_toolbar={true}
                                enable_publishing={false}
                                save_image={false}
                                hide_side_toolbar={true}
                                container_id={`chart-${trade.id}`}
                                isTransparent={true}
                                height={window.innerWidth < 600 ? 300 : 400}
                                width="100%"
                              />
                          </Box>
                        </AccordionDetails>
                      </Accordion>
                      </Card>
                    ))}
                  </Box>
                ) : (
                  <Box sx={{ textAlign: 'center', padding: { xs: 2, sm: 4 } }}>
                    <Typography 
                      variant="h6" 
                      className="text-secondary"
                      sx={{ fontSize: { xs: '1.1rem', sm: '1.25rem' } }}
                    >
                      No trades available
                    </Typography>
                    <Typography 
                      variant="body2" 
                      className="text-muted"
                      sx={{ fontSize: { xs: '0.8rem', sm: '0.875rem' } }}
                    >
                      Trade history will appear here when available
                    </Typography>
                  </Box>
                )}
              </CustomTabPanel>
            </Card>
        </Fragment>
      ))}

        {/* Enhanced Copy Trading Modal */}
<Dialog
          fullWidth
          maxWidth="sm"
        open={open}
        TransitionComponent={Transition}
        keepMounted
        onClose={handleClose}
          PaperProps={{
            sx: {
              background: 'var(--gradient-card)',
              border: '1px solid var(--border-primary)',
              borderRadius: 'var(--radius-lg)',
              backdropFilter: 'blur(20px)'
            }
          }}
        >
          <DialogContent sx={{ padding: 4 }}>
            <Box sx={{ textAlign: 'center', marginBottom: 3 }}>
              <Typography variant="h5" className="text-display gradient-text" sx={{ marginBottom: 1 }}>
                Copy {selectedtrader.trader_name}
              </Typography>
              <Typography variant="body2" className="text-secondary">
                Configure your copy trading parameters
              </Typography>
            </Box>

            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
              {/* Copy Proportion */}
              <FormControl fullWidth>
                <InputLabel sx={{ color: 'var(--text-secondary)' }}>Copy Proportion</InputLabel>
                            <OutlinedInput
                            value={proportion}
                  onChange={(e) => {
                    setAmount(e.target.value * selectedtrader.min_amount); 
                    setProportion(e.target.value)
                  }}
                  type="number"
                  label="Copy Proportion"
                  sx={{
                    '& .MuiOutlinedInput-notchedOutline': {
                      borderColor: 'var(--border-primary)'
                    },
                    '&:hover .MuiOutlinedInput-notchedOutline': {
                      borderColor: 'var(--primary-orange)'
                    },
                    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                      borderColor: 'var(--primary-orange)'
                    }
                  }}
                />
                {error !== '' && error.proportion && (
                  <Typography color="error" variant="caption">
                    {error.proportion}
                            </Typography>
                )}
                        </FormControl>
                        
              {/* Quick Proportion Buttons */}
              <Box sx={{ display: 'flex', justifyContent: 'space-between', gap: 1 }}>
                {[1, 2, 3, 4, 5].map((multiplier) => (
                  <Chip 
                    key={multiplier}
                    label={`${multiplier}X`}
                    onClick={() => {
                      setAmount(selectedtrader.min_amount * multiplier); 
                      setProportion(multiplier)
                    }}
                    sx={{
                      flex: 1,
                      height: 36,
                      background: proportion === multiplier ? 'var(--gradient-primary)' : 'var(--bg-tertiary)',
                      color: proportion === multiplier ? 'white' : 'var(--text-secondary)',
                      '&:hover': {
                        background: proportion === multiplier ? 'var(--gradient-primary)' : 'var(--bg-card-hover)'
                      }
                    }}
                  />
                ))}
                        </Box>

              {/* Amount Display */}
              <FormControl fullWidth>
                <InputLabel sx={{ color: 'var(--text-secondary)' }}>Amount To Pay</InputLabel>
                          <OutlinedInput
                            readOnly
                            value={amount}
                  type="number"
                            label="Amount To Pay"
                  sx={{
                    '& .MuiOutlinedInput-notchedOutline': {
                      borderColor: 'var(--border-primary)'
                    }
                  }}
                          />
                        </FormControl>
                      
              {/* Payment Source */}
              <FormControl fullWidth>
                <InputLabel sx={{ color: 'var(--text-secondary)' }}>Payment Source</InputLabel>
                          <Select
                  value={source}
                  onChange={(e) => {
                    setSource(e.target.value);
                    getCoinDetails(e.target.value);
                  }}
                  label="Payment Source"
                  sx={{
                    '& .MuiOutlinedInput-notchedOutline': {
                      borderColor: 'var(--border-primary)'
                    },
                    '&:hover .MuiOutlinedInput-notchedOutline': {
                      borderColor: 'var(--primary-orange)'
                    },
                    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                      borderColor: 'var(--primary-orange)'
                    }
                  }}
                >
                  <MenuItem value="">Select Payment Source</MenuItem>
                  <MenuItem value="Overall Asset">
                    Overall Asset (Balance: {formatPrice(fundingBal)})
                              </MenuItem> 
                          </Select>
                {error !== '' && error.source && (
                  <Typography color="error" variant="caption">
                    {error.source}
                          </Typography>
                )}
                      </FormControl>

              {/* Payment Details */}
              {selectedCoin !== null && (
                <Box>
                  <Alert 
                    severity="info" 
                    sx={{ 
                      marginBottom: 2,
                      background: 'var(--bg-tertiary)',
                      border: '1px solid var(--border-primary)',
                      color: 'var(--text-secondary)'
                    }}
                  >
                    {selectedCoin.wallet_type === 'bank' 
                      ? `Make payment to our ${selectedCoin.coin_name} account using the details below`
                      : `Send ${formatPrice(amount)} worth of ${selectedCoin.coin_name} to the address below`
                    }
                        </Alert>    

                  {selectedCoin.wallet_type === 'Crypto' && (
                    <Box sx={{ display: 'flex', justifyContent: 'center', marginBottom: 2 }}>
                      <QRCode 
                        qrStyle="dots" 
                        value={selectedCoin.address} 
                        size={200}
                        logoImage=""
                      />
                      </Box>
                  )}

                  <CopyToClipboard 
                    onCopy={() => {
                      setbuttonText(selectedCoin.wallet_type === 'bank' ? 'Account Details Copied' : 'Address Copied');
                      setTimeout(() => setbuttonText(null), 2000);
                    }} 
                    text={selectedCoin.address}
                  >
                                  <TextField
                      fullWidth
                      multiline
                      rows={2}
                      value={selectedCoin.address}
                      label={buttonText || `Click to copy ${selectedCoin.coin_name} ${selectedCoin.wallet_type === 'bank' ? 'bank details' : 'address'}`}
                      sx={{
                        '& .MuiOutlinedInput-notchedOutline': {
                          borderColor: 'var(--border-primary)'
                        },
                        '&:hover .MuiOutlinedInput-notchedOutline': {
                          borderColor: 'var(--primary-orange)'
                        }
                      }}
                    />
                          </CopyToClipboard>
                          </Box>
              )}

              {/* Action Button */}
              <Button 
                onClick={postInvestment} 
                disabled={isInvesting}
                variant="contained"
                size="large"
                sx={{
                  height: 56,
                  fontSize: 16,
                  fontWeight: 700,
                  textTransform: 'none',
                  background: 'var(--gradient-primary)',
                  color: '#FFFFFF',
                  border: 'none',
                  marginTop: 2,
                  '&:hover': {
                    background: 'var(--gradient-primary)',
                    transform: 'translateY(-1px)',
                    boxShadow: '0 8px 24px rgba(247, 147, 26, 0.4)',
                    color: '#FFFFFF'
                  },
                  '&:disabled': {
                    background: 'var(--bg-tertiary)',
                    color: 'var(--text-secondary)'
                  }
                }}
              >
                {isInvesting ? (
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, color: '#FFFFFF' }}>
                    <CircularProgress size={20} sx={{ color: '#FFFFFF' }} />
                    Processing...
          </Box> 
                ) : (
                  'Start Copying'
                )}
          </Button>      
            </Box>
        </DialogContent>
      </Dialog>
      </Box>
    </div>
  )
}

export default TraderSingle
